import { copyMailTemplates } from '@/API/repositories/mailTemplate';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';

export const useMakeMailTemplateCopy = ({ copy, setCopy }) => {
	const [selectedLanguages, setSelectedLanguages] = useState([]);

	const { addMessage } = useMessageQueueContext();

	const {
		COUNTRIES: nativeLanguageOptions,
	} = useCommonDataContext();

	const handleCopyTemplatesMutation = useMutation({
		mutationFn: (payload) => copyMailTemplates(payload),
		onSuccess: () => {
			addMessage('New templates added', 'success');
			setCopy(() => null);
		},
		onError: () => {
			addMessage('STH went wrong tell IT', 'error');
		},
	});

	const handleCopyTemplates = () => {
		
		if (selectedLanguages.length === 0) {
			addMessage('Select at least one language', 'error');
			return;
		}
		
		const payload = {
			templateId: copy._id,
			toLangShorts: selectedLanguages.map((sl) => sl.value),
		};

		handleCopyTemplatesMutation.mutate(payload);
	};

	return {
		handleCopyTemplates,
		isLoading: handleCopyTemplatesMutation.isPending,
		selectedLanguages,
		setSelectedLanguages,
		nativeLanguageOptions,
	};
};
